import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useSigninModal } from "../../context/SigninModalContext";
import "./ConvertBand.scss";

/**
 * Mid/bottom conversion band for marketing pages.
 * Primary: start free (sign in). Secondary: extension. Tertiary: optional link.
 */
const ConvertBand = ({
  eyebrow = "Social shopping · simpler checkout",
  title = "Shop with friends. Checkout without the chaos.",
  body = "Start free with your email, then save across stores, share when you want, and finish with affiliate or direct purchase.",
  primaryLabel = "Start free",
  showExtension = true,
  showIosApp = true,
  tertiaryTo = "/about",
  tertiaryLabel = "Better shopping, built social",
  id = "convert-band",
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const { openSignin } = useSigninModal();

  return (
    <motion.section
      id={id}
      className="convert-band"
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 24 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="convert-band__inner">
        {eyebrow ? <p className="convert-band__eyebrow">{eyebrow}</p> : null}
        <h2 className="convert-band__title">{title}</h2>
        {body ? <p className="convert-band__body">{body}</p> : null}
        <div className="convert-band__actions">
          <button
            type="button"
            className="convert-band__btn convert-band__btn--primary"
            onClick={openSignin}
          >
            {primaryLabel}
          </button>
          {showIosApp && (
            <a
              className="convert-band__btn convert-band__btn--ghost convert-band__btn--ios"
              href="https://apps.apple.com/us/app/ollacart/id6476688090"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get the iOS app
            </a>
          )}
          {showExtension && (
            <a
              className="convert-band__btn convert-band__btn--ghost convert-band__btn--extension"
              href="https://chromewebstore.google.com/detail/ollacart-extension/hpbmlmabfkbhmhjhocddfckebbnbkcbm"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get the extension
            </a>
          )}
          {tertiaryTo && tertiaryLabel ? (
            tertiaryTo.startsWith("http") || tertiaryTo.startsWith("/#") || tertiaryTo.startsWith("#") ? (
              <a className="convert-band__text-link" href={tertiaryTo}>
                {tertiaryLabel}
              </a>
            ) : (
              <Link className="convert-band__text-link" to={tertiaryTo}>
                {tertiaryLabel}
              </Link>
            )
          ) : null}
        </div>
      </div>
    </motion.section>
  );
};

export default ConvertBand;
